export const EMPTY_MAP: ReadonlyMap<never, never> = new Map<never, never>();
